/**
 * This component holds the whole app ui routing system, lazy loads private routes
 */
import React, { Suspense, lazy, useEffect } from "react";
import { Route, Switch, BrowserRouter, HashRouter } from "react-router-dom";
import ErrorThrower from "./ErrorThrower";
import fetchRoute from "utils/routes";
import GenericWrapper from "assets/js/components/GenericWrapper";
import OnboardingFlow from "assets/js/scenes/OnBoardingFlow/OnBoardingFlow";
import SpinnerContainer from "assets/js/components/SpinnerContainer";
import PublicHash from "assets/js/scenes/publicHash/PublicHash";
import { setLocalLocize } from "utils/languages";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import store from "./store";

const UI = lazy(() => import("assets/js/UI"));

function UIMain() {
	useEffect(() => {
		if (window.location.hash.includes(fetchRoute("public"))) {
			setLocalLocize();
		}

		const phInitId =
			store.getState().brand?.client_config?.segment_config?.phId;
		if (
			phInitId &&
			store.getState().brand?.client_config?.segment_config?.enabled
		) {
			posthog.init(phInitId, {
				api_host:
					store.getState().brand?.client_config?.segment_config?.phServer,
			});
		}
	}, []);
	return (
		<PostHogProvider client={posthog}>
			<BrowserRouter>
				<GenericWrapper>
					<ErrorThrower>
						<Suspense fallback={<></>}>
							<Switch>
								<Route
									path={fetchRoute("public")}
									render={(props) => (
										<OnboardingFlow
											authenticated={false}
											fetchAccount={() => {}}
											{...props}
										/>
									)}
								/>
								{!window.location.hash.includes(fetchRoute("public")) && <UI />}
								<HashRouter>
									<Switch>
										<Route
											path={fetchRoute("public")}
											render={() => <PublicHash />}
										/>
									</Switch>
								</HashRouter>
							</Switch>
						</Suspense>
					</ErrorThrower>
				</GenericWrapper>
			</BrowserRouter>
		</PostHogProvider>
	);
}
export default UIMain;
